import React, { FC, ReactNode } from "react";
import { TreeItem } from "@mui/x-tree-view";
import { Flue } from "./Flue";
import { useTranslation } from "react-i18next";
import { FlueIcon } from "./FlueIcon";
import { Stack, Tooltip, Typography } from "@mui/material";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";

export interface FlueTreeItemProps {
  flue: Flue;
  children?: ReactNode;
}

export const FlueTreeItem: FC<FlueTreeItemProps> = (props) => {
  const { flue } = props;
  const { t } = useTranslation("my-chimney-ts-translations");

  const shared = flue.fields.shared ?? false;
  return (
    <TreeItem
      itemId={`Flue:${flue.id}`}
      label={
        <Stack direction={"row"}>
          <Stack direction={"row"} useFlexGap gap={1} sx={{ flex: 1 }}>
            <Typography sx={{ flexGrow: 1 }}>{t("Flue")}</Typography>
            <Typography sx={{ flexGrow: 1 }}>{flue.fields?.mcName}</Typography>
          </Stack>
          <Stack direction={"row"} useFlexGap gap={1}>
            {shared && (
              <Tooltip title={t("Shared")}>
                <PeopleRoundedIcon />
              </Tooltip>
            )}
          </Stack>
        </Stack>
      }
      slots={{
        expandIcon: FlueIcon,
        collapseIcon: FlueIcon,
        endIcon: FlueIcon,
      }}
    >
      {props.children}
    </TreeItem>
  );
};
